import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-company-modal',
  templateUrl: './info-company-modal.component.html',
  styleUrls: ['./info-company-modal.component.scss']
})
export class InfoCompanyModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
